<script setup>

import {useRoute} from "vue-router";
import BrowsePurchaseOrder from "@/components/orders/BrowsePurchaseOrder";
import PurchaseOrderEntry from "@/components/orders/PurchaseOrderEntry";

const route = useRoute();

</script>

<template>
  <div v-if="route.params.id ==='new'">
    <PurchaseOrderEntry></PurchaseOrderEntry>
  </div>
  <BrowsePurchaseOrder v-else></BrowsePurchaseOrder>
</template>

<style scoped>

</style>
